var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreyConsumerEngagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.75H6.75V4.5H12.75V6H8.25V9.75Z",
    fill: "#C3C3C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20.25H12.75V18.75H16.5V14.25H18V20.25Z",
    fill: "#C3C3C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 21H3.75V18.75C3.75 16.65 5.4 15 7.5 15C9.6 15 11.25 16.65 11.25 18.75V21ZM5.25 19.5H9.75V18.75C9.75 17.475 8.775 16.5 7.5 16.5C6.225 16.5 5.25 17.475 5.25 18.75V19.5Z",
    fill: "#C3C3C3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.5C5.85 16.5 4.5 15.15 4.5 13.5C4.5 11.85 5.85 10.5 7.5 10.5C9.15 10.5 10.5 11.85 10.5 13.5C10.5 15.15 9.15 16.5 7.5 16.5ZM7.5 12C6.675 12 6 12.675 6 13.5C6 14.325 6.675 15 7.5 15C8.325 15 9 14.325 9 13.5C9 12.675 8.325 12 7.5 12Z",
    fill: "#C3C3C3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13.5H13.5V11.25C13.5 9.15 15.15 7.5 17.25 7.5C19.35 7.5 21 9.15 21 11.25V13.5ZM15 12H19.5V11.25C19.5 9.975 18.525 9 17.25 9C15.975 9 15 9.975 15 11.25V12Z",
    fill: "#C3C3C3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 9C15.6 9 14.25 7.65 14.25 6C14.25 4.35 15.6 3 17.25 3C18.9 3 20.25 4.35 20.25 6C20.25 7.65 18.9 9 17.25 9ZM17.25 4.5C16.425 4.5 15.75 5.175 15.75 6C15.75 6.825 16.425 7.5 17.25 7.5C18.075 7.5 18.75 6.825 18.75 6C18.75 5.175 18.075 4.5 17.25 4.5Z",
    fill: "#C3C3C3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyConsumerEngagement);
export default __webpack_public_path__ + "static/media/greyConsumerEngagement.6257695668ebd3c5c84e4253c974dd48.svg";
export { ForwardRef as ReactComponent };